import styled from 'styled-components';
import { ThemeColours } from '../../../../../../styles/ThemeColours';
import { Breakpoint, BorderRadius } from '../../../../../../styles/constants';

export const Clickable = styled.div`
  border-radius: ${BorderRadius.SMALL};
  cursor: pointer;

  ${Breakpoint.SMALL} {
    &:active,
    :hover,
    :focus {
      background: ${ThemeColours.mono100};
      min-width: 334px;
      outline: none;
    }
  }
`;

export const Item = styled.div`
  box-sizing: border-box;
  width: 100%;
`;
